var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 23,
    height: 23,
    transform: "translate(21.5 92.5)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-21.5 -92.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.056,2.15a.358.358,0,0,0-.358.358V3.683l-1.883.627-3.564.713a.36.36,0,0,0-.122.049L.187,7.58a.359.359,0,0,0-.11.495l2.508,3.942a.358.358,0,0,0,.544.072l.835-.757v9.81a.358.358,0,0,0,.358.358H15.789a.358.358,0,0,0,.358-.358V11.408L17,12.1a.351.351,0,0,0,.276.077.355.355,0,0,0,.244-.149l2.508-3.583a.358.358,0,0,0-.083-.5L16,5.085a.355.355,0,0,0-.14-.061L12.3,4.311l-1.883-.627V2.815A1.431,1.431,0,1,0,8.622,1.433a.358.358,0,1,0,.717,0,.717.717,0,1,1,.717.717Zm0,2.169,1.767.59a1.783,1.783,0,0,1-3.533,0Zm9.18,4.005L17.15,11.3l-1.134-.928a.358.358,0,0,0-.586.278V20.783H4.681V10.521a.358.358,0,0,0-.6-.265L2.963,11.273.875,7.993l3.583-2.28,3.125-.625a2.508,2.508,0,0,0,4.943,0l3.115.623Zm0,0",
    transform: "translate(23.695 94)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrands);
export default __webpack_public_path__ + "static/media/brands.38aa7ff5.svg";
export { ForwardRef as ReactComponent };